var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "mb-2"
  }, [_vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(" 載入中... ")])]) : _c('div', {
    staticClass: "earn-count"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/earn-count-bg.jpg")
    }
  }), _c('router-link', {
    staticClass: "earn-count__rules",
    attrs: {
      "to": {
        name: 'LiffProjAbbottAnd2026LotteryQ2Rules',
        query: _vm.$route.query
      }
    }
  }, [_c('img', {
    staticClass: "rules-btn img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-rules.png")
    }
  })]), _c('span', {
    staticClass: "earn-count__count"
  }, [_vm._v(_vm._s(_vm.earnCount))]), _c('div', {
    staticClass: "earn-count__info"
  }, [_vm._m(1), _vm.expired ? _c('router-link', {
    attrs: {
      "to": {
        name: 'LiffProjAbbottAnd2026LotteryResult',
        query: {
          event_code: 'e2026Q1'
        }
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-3.png")
    }
  })]) : _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-2.png")
    }
  })])], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "https://liff.line.me/1565710169-g0YZ75wA",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/earn-count-btn-1.png")
    }
  })]);
}]

export { render, staticRenderFns }